<script lang="ts">
  import { setContext } from "svelte";
  import { errorComponent, navigatorOptions } from "@kestrel/client";
  import { kestrelContext } from "./stores.js";
  import { getComponentByIslandId } from "./component/islands.js";
  import type { KestrelStores } from "@kestrel/stores";
  import type { RootProps } from "./utils/root.types.js";

  const { component, stores, island = "default" }: RootProps = $props();

  setContext<KestrelStores>(kestrelContext, stores);
  const { data, form, error, component: componentStore } = stores;

  let Component = $state(component);

  /*                                                                             */
  /*                   */
  if (!import.meta.env.SSR && navigatorOptions) {
    componentStore.subscribe((resolvedComponent) => {
      /*                                                                      */
      const islandComponent = getComponentByIslandId(island, resolvedComponent);

      /*                                                    */
      if (Component === islandComponent) return;
      Component = islandComponent;
    });
  }
</script>

<svelte:boundary>
  {#if $error}
    <!-- This means, the error component will never be rendered on the server -->
    {#await errorComponent() then { default: ErrorComponent }}
      <ErrorComponent error={$error} />
    {/await}
  {:else if Component}
    <Component data={$data} form={$form} />
  {/if}

  {#snippet failed(error)}
    {#if import.meta.env.DEV}
      <span>Could not render "{island}": {error}</span>
    {:else}
      {@html `<!-- Could not render "${island}": ${error}-->`}
    {/if}
  {/snippet}
</svelte:boundary>
